import { useMediaQuery } from './use-media-query';

/**
 * The viewport widths the app actually branches on, named once.
 *
 * These are Tailwind's own `sm` and `md` stops, expressed as the `max-width`
 * side of them so a hook reads "below this" the way a `sm:` class reads "at
 * this and above". Keeping them here rather than inline at each call site is
 * what stops a `639px` here and a `640px` there from putting a component's
 * JavaScript branch one pixel out of step with its own CSS.
 */
export const BELOW_SM_QUERY = '(max-width: 639px)';
export const BELOW_MD_QUERY = '(max-width: 767px)';

/**
 * Below Tailwind's `sm` — a phone held upright.
 *
 * The width at which a control band stops being a band: a row of filter chips
 * becomes one menu, a page title gives up its subtitle, a breadcrumb trail
 * gives up everything but the page's own name. Use it where the layout does not
 * just reflow but actually changes shape, and reach for a `sm:` class instead
 * wherever CSS can say it.
 */
export const useIsBelowSm = (): boolean => useMediaQuery(BELOW_SM_QUERY);

/**
 * Below Tailwind's `md` — the stop the app shell's own chrome uses.
 *
 * This is the one that decides whether the sidebar is a sheet rather than a
 * rail, and whether the chat's artifact panel is a split or a pair of tabs.
 * Anything keyed to the same decision should read it from here, so the pieces
 * of one layout cannot disagree about which layout they are in.
 */
export const useIsBelowMd = (): boolean => useMediaQuery(BELOW_MD_QUERY);
